import React, { useRef } from "react";
import { CardMedia, IconButton } from "@mui/material";
import { castArray, compact, filter, includes, map } from "lodash";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

import { makeStyles } from "../../AppContainer/mui-theme";
import { appfrontCdnRoot, promotionMediaType } from "../../../utils/media";
import "../slick-theme.css";

export default (props) => {
  const { appStyles, widget } = props;

  const { classes } = useStyles(appStyles);
  const sliderRef = useRef(null);

  const PrevArrow = ({ onClick = () => {} }) => (
    <IconButton onClick={onClick} className={classes.prevArrow}>
      <ChevronLeft />
    </IconButton>
  );

  const NextArrow = ({ onClick = () => {} }) => (
    <IconButton onClick={onClick} className={classes.nextArrow}>
      <ChevronRight />
    </IconButton>
  );

  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1,
        }}
      >
        <ul className="gallery" style={{ margin: 0, padding: 0 }}>
          {dots}
        </ul>
      </div>
    ),
  };

  const mediaItems = [
    ...filter(
      compact(
        castArray(
          (widget.image && {
            ...widget.image,
            mediaType: promotionMediaType.image,
          }) ||
            widget.media
        )
      ),
      ({ mediaType }) =>
        includes(
          [promotionMediaType.image],
          mediaType
        )
    ),
  ];

  return (
    <Slider ref={sliderRef} {...settings} className={classes.slider}>
      {map(mediaItems, (mediaItem, index) => (
        <CardMedia
          style={{ pointerEvents: "none" }}
          key={`${index}` + mediaItem.key}
          image={`${appfrontCdnRoot}/${mediaItem.key}`}
          component="img"
        />
      ))}
    </Slider>
  );
};

const useStyles = makeStyles()(() => ({
  prevArrow: {
    position: "absolute",
    top: "50%",
    left: "5px",
    transform: "translateY(-50%)",
    zIndex: 2,
    color: "rgba(255, 255, 255, 0.8)",
  },
  nextArrow: {
    position: "absolute",
    top: "50%",
    right: "5px",
    transform: "translateY(-50%)",
    zIndex: 2,
    color: "rgba(255, 255, 255, 0.8)",
  },
  slider: {
    height: "100vw",
    width: "100vw",
  },
}));
